"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeOfField = void 0;
const zod_1 = require("zod");
function getTypeOfField(schema, fieldPath) {
    const keys = Array.isArray(fieldPath) ? fieldPath : fieldPath.split('.');
    const key = keys.shift(); // Take out the first key
    if (key === undefined) {
        // We've traversed all keys, determine the type of the final field
        switch (schema._def.type) {
            case 'string':
                return 'string';
            case 'number':
                return 'number';
            case 'boolean':
                return 'boolean';
            case 'date':
                return 'date';
            case 'array':
                return 'array';
            case 'object':
                return 'object';
            default:
                return 'undefined'; // Unknown or unsupported type
        }
    }
    if (schema instanceof zod_1.ZodEffects) {
        return getTypeOfField(schema._def.schema, keys);
    }
    else if (schema instanceof zod_1.ZodOptional) {
        return getTypeOfField(schema.unwrap(), keys);
    }
    else if (schema instanceof zod_1.ZodObject) {
        const fieldSchema = schema.shape[key];
        if (fieldSchema === undefined) {
            return 'undefined'; // Path does not exist in schema
        }
        else {
            return getTypeOfField(fieldSchema, keys);
        }
    }
    else {
        // The schema type doesn't support nested fields
        return 'undefined';
    }
}
exports.getTypeOfField = getTypeOfField;
//# sourceMappingURL=getTypeOfSchema.js.map